<template>
  <router-view
    :viewPermission="viewPermission"
    :createPermission="createPermission"
    :editPermission="editPermission"
    :deletePermission="deletePermission"
  />
</template>

<script>
import { mapState } from 'vuex'
import accessMix from '@/services/accessmix.js'

export default {
  mixins: [accessMix],
  computed: {
    ...mapState(['user']),
    viewPermission() {
      return this.checkPermissions(this.user.permissions, 'deeplinks', 'view')
    },
    createPermission() {
      return this.checkPermissions(this.user.permissions, 'deeplinks', 'create')
    },
    editPermission() {
      return this.checkPermissions(this.user.permissions, 'deeplinks', 'edit')
    },
    deletePermission() {
      return this.checkPermissions(this.user.permissions, 'deeplinks', 'delete')
    },
  },
}
</script>
